import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useConsentAgreementFile } from "../hooks/useConsentAgreementFile";
import { useToken } from "../hooks/useToken";
import { ContestAgreementsError } from "./ContestAgreementsError";
import { ContestAgreementsFilePreview } from "./ContestAgreementsFilePreview";
import { ContestAgreementsMissingToken } from "./ContestAgreementsMissingToken";
import { ContestAgreementsSignButton } from "./ContestAgreementsSignButton";

const STATE_MISSING_TOKEN = "missing-token";
const STATE_FILE_PREVIEW = "file-preview";
const STATE_ERRORED = "errored";

export const ContestAgreements = () => {
  const token = useToken();
  const { t } = useTranslation();
  const hasToken = Boolean(token);

  const file = useConsentAgreementFile(token);

  const state = useMemo(() => {
    if (!hasToken) {
      return STATE_MISSING_TOKEN;
    }
    if (file.error) {
      return STATE_ERRORED;
    }
    return STATE_FILE_PREVIEW;
  }, [hasToken, file.error]);

  const disabled = file.loading || state !== STATE_FILE_PREVIEW;

  return (
    <Card className="m-4">
      <CardHeader className="flex flex-row justify-between items-center">
        <CardTitle className="grow">
          {t("contestAgreements.title.single")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {state === STATE_FILE_PREVIEW && (
          <ContestAgreementsFilePreview
            fileUrl={file.url}
            fileName={file.name}
          />
        )}
        {state === STATE_MISSING_TOKEN && <ContestAgreementsMissingToken />}
        {state === STATE_ERRORED && <ContestAgreementsError />}
      </CardContent>
      <CardFooter className="flex flex-row justify-end items-center gap-3">
        <span className="text-sm text-muted-foreground">
          {t("contestAgreements.signAgreementButtonDescription")}
        </span>
        <ContestAgreementsSignButton disabled={disabled} />
      </CardFooter>
    </Card>
  );
};
